module.exports = __webpack_public_path__ + "static/media/hand-drawn-genes-and-dna-illustration-png.464a714c.png";